import { Component, OnInit, ViewChild } from '@angular/core'
// import { AuthService } from 'src/app/services/auth.service'
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component'
import { WbsService } from 'src/app/services/wbs.service'
import { FrontEndParams } from '@interserve/igx-angular'
import { environment } from 'src/environments/environment'
import { IsAccountService } from '@interserve/angular'

@Component({
    selector: 'app-create-arear',
    templateUrl: './create-area.component.html',
    styleUrls: ['./create-area.component.scss'],
})
export class CreateAreaComponent implements OnInit {
    @ViewChild('snackbar', { static: true }) private snackbar!: SnackbarComponent

    public frontendCd = 'areaMappingV3'
    public frontendCdHub = 'areaMappingHubV3'
    public title = 'エリア作成'

    environmentKey = environment.environmentKey

    public apiLoading = false
    public loading = false

    public customerId = ''

    //紐づけライブラリ用
    public mappingParams!: FrontEndParams
    public hubParams!: FrontEndParams

    constructor(
        private wbsService: WbsService,
        // private authService: AuthService
        private isAccountService: IsAccountService
    ) {}

    ngOnInit() {
        this.customerId = this.isAccountService.account?.customerId ?? ''

        this.initialize()
    }
    async initialize() {
        this.loading = true
        try {
            //フロントエンド設定を紐づけに渡す
            let param = { customerId: this.customerId }
            this.mappingParams = this.wbsService.setFrontendParams(this.frontendCd, param)
            this.hubParams = this.wbsService.setFrontendParams(this.frontendCdHub, param)

            this.loading = false
        } catch (error) {
            this.snackbar.error('画面の初期化が失敗しました')
            this.loading = false
        }
    }
}
